import { Tooltip as T } from "radix-ui";
import type { ReactNode } from "react";
import { Kbd } from "./kbd";

export function TooltipProvider({ children }: { children: ReactNode }) {
  return (
    <T.Provider delayDuration={350} skipDelayDuration={150}>
      {children}
    </T.Provider>
  );
}

export function Tip({
  label,
  keys,
  side = "bottom",
  children,
}: {
  label: ReactNode;
  keys?: string;
  side?: "top" | "bottom" | "left" | "right";
  children: ReactNode;
}) {
  return (
    <T.Root>
      <T.Trigger asChild>{children}</T.Trigger>
      <T.Portal>
        <T.Content
          side={side}
          sideOffset={6}
          className="z-50 flex max-w-xs items-center gap-2 rounded-md border border-line bg-raised px-2 py-1 text-fg text-xs shadow-xl"
        >
          {label}
          {keys && <Kbd>{keys}</Kbd>}
        </T.Content>
      </T.Portal>
    </T.Root>
  );
}
